export default {
      id: "docs-usage",
      viewBox: "0 0 24 24",
      url: __webpack_public_path__ + "sprite.svg#docs-usage",
      toString: function () {
        return this.url;
      }
    }